import { User } from '@bonhams1793/bonhams-typescript'

import { createAuthenticatedAxiosClient } from '@nx/axios-client'
import { BonhamsCookies } from '@nx/global-types'

export async function getUser(baseURL: string, cookies: BonhamsCookies) {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies?.bonhams_access || '',
    refreshTokenSSR: cookies?.bonhams_token || '',
    baseURL,
  })

  return authenticatedAxiosClient
    .post<User | null>(
      '/api/v2/client/token/',
      {
        token: cookies.bonhams_access,
      },
      {
        transformRequest: [
          function (data, headers) {
            delete headers.Authorization

            return JSON.stringify(data)
          },
        ],
        headers: {
          'Content-Type': 'application/json',
        },
        baseURL,
      }
    )
    .then((response) => response.data || null)
}
